<template>
  <a-modal width="60%" :title="form.id ? '金融需求编辑' : '金融需求新增'" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
           :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <template #footer>
      <a-button key="back" @click="onClose">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="onSubmitA">保存</a-button>
    </template>
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
        <a-form-item label="year" name="year">
          <a-input v-model:value="form.year" />
        </a-form-item>
        <a-form-item label="firstReviewer" name="firstReviewer">
          <a-input v-model:value="form.firstReviewer" />
        </a-form-item>
        <a-form-item label="secondReviewer" name="secondReviewer">
          <a-input v-model:value="form.secondReviewer" />
        </a-form-item>
      </div>
      <div>
        <a-row :gutter="[24, 8]">

          <a-col :span="24">
            <a-form-item label="1.有无贷款情况" name="isLoad">
              <a-radio-group v-model:value="form.isLoad" name="radioGroup" @change="isLoadChange">
                <a-radio value="1">有</a-radio>
                <a-radio value="0">无</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

        <!-- <a-row :gutter="[24, 8]"> -->
          <a-col :span="24">
            <a-form-item name="enterpriseFinanceDemandLoadList">
              <a-button type="primary" @click="handleAdd" :disabled="form.isLoad==='0' || !form.isLoad" style="color:#fff !important;">添加</a-button>
              <div style="color:#ff4d4f;margin:6px 0;"></div>
              <a-table :columns="columns"  :data-source="form.enterpriseFinanceDemandLoadList" bordered :pagination="false">
                <template #customTitle1>
                  <div>
                    <span style="color: #ff4d4f;">*</span> 合作银行
                  </div>
                </template>
                <template #customTitle2>
                  <div>
                    <span style="color: #ff4d4f;">*</span> 贷款额度（万元）
                  </div>
                </template>
                <template #customTitle3>
                  <div>
                    <span style="color: #ff4d4f;">*</span> 利率
                  </div>
                </template>
                <template #loadAmount="{ record }">
                  <a-input-number :min='0' placeholder="请输入金额" v-model:value="record.loadAmount" style="width: 100%" />
                </template>
                <template #loadBank="{ record }">
                  <dict-select :dict-name="'intentionbank'" @update:value="loadBankChange($event,record)" placeholder="请选择银行" v-model:value="record.loadBank"></dict-select>
                </template>
                <template #loadBankname="{ record }">
                  <a-input  placeholder="请输入银行名称" :disabled="record.otherType1"  v-model:value="record.loadBankname"/>
                </template>
                <template #loadRate="{ record }">
                  <a-input-number  :min="0" placeholder="请输入利率" v-model:value="record.loadRate" style="width: 100%" />
                </template>
                <template #action="{ record }">
                  <div class="table-row-operations">
                    <a style="color:red;" @click="deleteLine(record.sortNum)">删除</a>
                  </div>
                </template>
                <span>
                    <a-popconfirm title="确定要删除吗?" @confirm="deleteLine(record.sortNum)">
                      <a>删除</a>
                    </a-popconfirm>
                  </span>
              </a-table>
            </a-form-item>
          </a-col>
        <!-- </a-row> -->

          <a-col :span="24">
            <a-form-item label="2.有无贷款需求" name="isDemand">
              <a-radio-group v-model:value="form.isDemand" name="radioGroup" @change="isDemandChange">
                <a-radio value="1">有</a-radio>
                <a-radio value="0">无</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.isDemand==='1'">
            <a-form-item label="贷款意向额度（万元）" name="intentionAmount">
              <a-input-number  v-model:value.number="form.intentionAmount"  :min='0'  placeholder="请输入贷款意向额度（万元）" style="width: 100%" />
<!--              <a-input v-model:value="form.intentionAmount" placeholder="请输入贷款意向额度（万元）" />-->
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.isDemand==='1'">
            <a-form-item label="合作银行（可多选）" name="intentionBank">
              <DictSelect @update:value="intentionBankChange" multiple="true"  v-model:value="form.intentionBank" :dict-name="'intentionbank'" placeholder="请选择合作银行（可多选）" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.isDemand==='1'">
            <a-form-item label="其他银行名称（填写多个请使用逗号隔开）" name="intentionBankname">
               <a-input :disabled="otherType" v-model:value="form.intentionBankname" placeholder="请输入其他银行名称" />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="form.isDemand==='1'">
            <a-form-item label="期望利率(%)" name="intentionRate">
              <a-input-number   v-model:value.number="form.intentionRate" :min='0' placeholder="请输入期望利率(%)" style="width: 100%" />
<!--              <a-input  v-model:value="form.intentionRate" placeholder="请输入期望利率(%)" />-->
            </a-form-item>
          </a-col>
        </a-row>
      </div>

      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
  <a-modal v-model:visible="isAllowVisible" :closable="false" :maskClosable="false">
    <template #footer>
      <div>
        <a-button type="primary" @click="handleOk">去填报</a-button>
      </div>
    </template>
<!--    <h3>2024年对应的企业积分制未填报！</h3>-->
    <h3>{{form.year}}年对应的企业积分制未填报！</h3>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin, dictMixin } from "@/mixins";
import DictSelect from "@/components/other/DictSelect";
import { policy, dateFormat } from "@/config/variableConfig";
import {sys_finance_demand} from "@/api/financeDemand";
import { sys_policy } from "@/api/policyService";
const columns = [
  // {title: "序号", dataIndex: "sortNum", key: "sortNum"},
  {dataIndex: "loadBank",width:240, slots: {title: 'customTitle1',customRender: "loadBank"}},
  {dataIndex: "loadBankname",title:'其他银行名称', slots: {customRender: "loadBankname"}},
  {dataIndex: "loadAmount", slots: {title: 'customTitle2',customRender: "loadAmount"}},
  {dataIndex: "loadRate",slots: {title: 'customTitle3',customRender: "loadRate"}},
  {title: "操作", dataIndex: "action", key: "action", slots: {title: 'customTitle5',customRender: "action"}},
];
export default {
  name: "UserModal",
  components: {  DictSelect },
  mixins: [formMixin, dictMixin],
  data() {
    return {
      obs: false,
      dictNames: 'intentionbank',
      columns,
      policy,
      dateFormat,
      isAllowVisible: false,
      list: [],
      form: {
        id: null,
        enterpriseFinanceDemandLoadList:[],
        year: new Date().getFullYear().toString()
      },
      editableData: {},
      rules: {
        isDemand:[dataCheck.required({})],
        isLoad:[dataCheck.required({})],
        intentionAmount:[{ type: 'number', message: '请输入数字' }],
        // intentionAmount:[dataCheck.required({}),dataCheck.regexp],
        intentionBankname :[],
        intentionBank :[dataCheck.required({})],
        intentionRate :[{ type: 'number', message: '请输入数字' }],
        id: [],
        year:[],
        enterpriseFinanceDemandLoadList: [],
        isSubmit: [],
        firstReviewer: [],
        secondReviewer: [],
      },
      submitUrl: sys_finance_demand.saveOrUpdate,
      submitType: 'json',
      otherType:true
    }
  },
  watch: {
    visible: {
      handler() {
        this.getIsAllowData(this.form.year)
      }
   },
      "form.intentionAmount"(n){
        this.form.intentionAmount = Number(n)
      },
      "form.intentionRate"(n){
          this.form.intentionRate = Number(n)
      },

  },
  methods: {
    getIsAllowData() {
      this.getAction({
          url: sys_policy.isFillIn + (new Date().getFullYear()-1)
      }).then(res => {
        if (res == false) {
          this.isAllowVisible = true
          this.form.year = (new Date().getFullYear()-1)
        }
      })
    },
      isDemandChange() {
          if (this.form.isDemand === '0') {
              this.form.intentionAmount = ''
              this.form.intentionBank = ''
              this.form.intentionBankname = ''
              this.form.intentionRate = ''
          }
      },
      isLoadChange() {
          if (this.form.isLoad === '0') {
              this.form.enterpriseFinanceDemandLoadList = []
          }
      },
    intentionBankChange(value){
      if(value.includes('7')){
         this.otherType = false
      }else {
        this.otherType = true
        this.form.intentionBankname = ''
      }
    },
    loadBankChange(value,row){
      if(value.includes('7')){
        row.otherType1 = false
      }else {
        row.otherType1 = true
        row.loadBankname = ''
      }
    },
    handleOk() {
      this.$router.push({ path: '/sys/manage' })
    },
    handleAdd() {
      const newData = {
        sortNum: this.form.enterpriseFinanceDemandLoadList ? this.form.enterpriseFinanceDemandLoadList.length + 1 : 1,
        loadBank: undefined,
        loadAmount:'',
        loadRate: '',
      }
      this.form.enterpriseFinanceDemandLoadList.push(newData)
    },
    deleteLine(key) {
      this.form.enterpriseFinanceDemandLoadList = this.form.enterpriseFinanceDemandLoadList.filter(item => item.sortNum !== key);
    },
    onSubmitA() {
      this.form.isSubmit = 0;
      this.form.year = new Date().getFullYear().toString()
        if ( this.form.isDemand ==='1' && this.form.intentionBank.includes('7') && !this.form.intentionBankname) {
            this.$notification.error({
                message: "请填写意向贷款银行名称"
            })
            return;
        }
        if(this.form.isLoad ==='1'){
            let remarkboolean = false;
            if(this.form.enterpriseFinanceDemandLoadList.length <=0){
                this.$notification.error({
                    message: "请填写贷款情况"
                })
                return;
            }else{
                this.form.enterpriseFinanceDemandLoadList.forEach(item=>{
                    if(!item.loadBankname && item.loadBank !== '7'){
                        item.loadBankname = ' '
                    }
                    if(!item.loadBankname && item.loadBank == '7'){
                        remarkboolean=true;
                    }
                })
                if(remarkboolean){
                    this.$notification.error({
                        message: "请检查，其他银行名称必填"
                    })
                    return
                }
            }
            if(this.allValuesNotEmpty(this.form.enterpriseFinanceDemandLoadList) === false){
                this.$notification.error({
                    message: "请检查必填项，必填项目不能为空"
                })
                return;
            }
        }
      this.onSubmit()
    },allValuesNotEmpty(data){
          const allValuesNotEmpty = data.every((obj) => {
              return Object.values(obj).every((value) => value !== "");
          })
          return allValuesNotEmpty
      },
  }
}
</script>
<style scoped lang="less">
:deep(.ant-table-body) {
  min-height: 100px;
}

:deep(.ant-table-placeholder) {
  display: none;
}
.title-01{
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span{
    font-size: 14px;
    color: #ff581e;
    font-weight: 500;
    cursor: pointer;
  }
}
</style>
